module.exports = __webpack_public_path__ + "static/media/assistencia.f986150d.jpg";